import { render, staticRenderFns } from "./ClientQuestion.vue?vue&type=template&id=e0910456&scoped=true&"
import script from "./ClientQuestion.vue?vue&type=script&lang=js&"
export * from "./ClientQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ClientQuestion.vue?vue&type=style&index=0&id=e0910456&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0910456",
  null
  
)

export default component.exports